import { OnInit, Component, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from '../../../../infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../../controls/search-complete-filter/search-complete-filter.component';
import { Router } from '@angular/router';
import { MenuService } from '../../../../services/menu.service';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { OrderBatch } from '../../../../model/logistics/order';
import { PagerControlComponent } from '../../../controls/pager/pager-control.component';
import { LogisticsService } from '../../../../services/logistics.service';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-send-order-logistics-search',
  templateUrl: './send-order-logistics-search.component.html',
  styleUrls: ['./send-order-logistics-search.component.css']
})
export class SendOrderLogisticsSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService
    , private authService: AuthService
    , private logisticsService: LogisticsService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Logística', 'envío de ordenes');
  }

  ngOnInit(): void {

  }

  rollBackOrderBach(orderBatch: OrderBatch): void {
    if (!orderBatch.CanEdit) {
      this.confirmDialogService.confirm('Revertir lote'
      , 'Está seguro que desea revertir el lote?', 'Sí', 'No').subscribe(async (value) => {
        if (value) {
          try {
            this.loading = true;
            await this.logisticsService.orderBatchRollBack(orderBatch, this.authService.getSectorId());
            await this.searchFilter.search();
          } catch (err) {
            this.notificationToastService.error(JSON.stringify(err), 'Recepción de órdenes');
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }

  async orderBatchDelete(orderBatch: OrderBatch) {
    this.confirmDialogService.confirm('Envio de órdenes'
      , 'Está seguro que desea deshabilitar?', 'Sí', 'No').subscribe(async (value) => {
        try {
          if (value && orderBatch.CanEdit) {
            this.loading = true;
            await this.logisticsService.orderBatchDelete(orderBatch);
            await this.searchFilter.search();
          }
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Envio de órdenes');
        } finally {
          this.loading = false;
        }
      });
  }

  async orderBatchEnable(orderBatch: OrderBatch) {
    try {
      if (orderBatch.Deleted) {
        this.loading = true;
        await this.logisticsService.orderBatchEnable(orderBatch);
        await this.searchFilter.search();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Envio de órdenes');
    } finally {
      this.loading = false;
    }
  }

  editOrderBach(orderBatch: OrderBatch): void {
    if (orderBatch.CanEdit) {
      this.router.navigate(['send-order-logistics-wizard', orderBatch.Id]);
    }
  }

  newOrderBatch(): void {
    this.router.navigate(['send-order-logistics-wizard']);
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<OrderBatch>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
